import { queryPriceField } from './discountedFrom';

/**
 * The pay-what-you-want amount seeded from the URL, in minor units (cents).
 *
 * A multi-price product is addressed per price (`?${reference}_pwyw=3500`), since
 * the unprefixed `pwyw` carries no reference and would seed whichever PWYW option
 * happened to be selected. Single-price products keep the unprefixed param.
 *
 * Returns null when there is no usable override, so the caller falls back to the
 * recovered draft amount or leaves the input empty.
 */
export default function resolvePwywQueryAmount({
  query = {},
  reference,
  isMultiPrice = false,
} = {}) {
  const raw = queryPriceField(reference, 'pwyw', query, { allowLegacyFallback: !isMultiPrice });
  if (raw == null) return null;
  const amount = Number(raw);
  return Number.isFinite(amount) && amount >= 0 ? amount : null;
}
